import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { NoticeToVacateSignature } from '../../models/noticetovacatesignature';

import { NtvService as NoticeToVacateService } from '../../../services/ntv.service';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.css']
})
export class CancelComponent implements OnInit {
  model: NoticeToVacateSignature = new NoticeToVacateSignature();
  cancelToken: string;
  successMessage: string;
  errorMessage: string;
  successfullyCanceledNtv: boolean;

  constructor(
    public ntvService: NoticeToVacateService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) { 
    const url = this.router.url.split('?')[0];
    const parameters = location.path().split('?')[1];
    
    if (parameters) {
      localStorage.removeItem('NTVErrorMessage');

      const params = parameters.split('&');

      const cancelTokenQuery = params.find(function (x) {
        return x.indexOf('cancelToken') > -1;
      });

      if (!cancelTokenQuery) {
        this.ntvService.handleError("ERROR: No cancel token query provided");
      }

      if (cancelTokenQuery) {
        const cancelToken: string = cancelTokenQuery.split('=')[1];
        localStorage.setItem('CancelToken', cancelToken);
        this.ntvService.getNoticeToVacateSignature(cancelToken)
          .subscribe(res => this.setSignatureAttributes(res), err => this.ntvService.handleError(err));
      }
    } else {
      const error: string = "ERROR: No cancel token provided";
      this.handleNTVCancelError(error);
    }

  }

  ngOnInit() {
    this.successMessage = null;
    this.errorMessage = null;
  }

  handleNTVCancelError(err) {
    this.errorMessage = err;
    this.ntvService.handleError(err);
  }

  onSubmit() {
    const cancelToken = localStorage.getItem('CancelToken');
    this.ntvService.cancelNoticeToVacate(cancelToken)
      .subscribe(res => this.handleCancelNTVResponse(res), err => this.ntvService.handleError(err));
  }

  setSignatureAttributes(ntvSignature: NoticeToVacateSignature) {
    this.model = ntvSignature;
  }

  handleCancelNTVResponse(cancelSuccessful: boolean) {
    if(cancelSuccessful) {
      this.successfullyCanceledNtv = true;
    } else {
      const error: string = "ERROR: Failed to cancel Notice to Vacate record";
      this.ntvService.handleError(error);
    }
  }

}
